import React, { useEffect, useRef } from 'react';

import { useClaim } from '~/components/ClaimContainer';
import { CliveInsightsContentV2 } from '~/components/ClaimPage/CliveApp/CliveInsights/views/v2/CliveInsightsContentV2';
import mixpanel from '~/components/CmsMain/mixpanel';
import { useCms } from '~/components/hooks/useCms';
import MIXPANEL_EVENTS from '~/server_shared/generated-types/MIXPANEL_EVENTS';

/**
 * The Claim Insights UI, which reads its data via useCliveInsightsViewModel. Also reports
 * the tab-opened event, which is why this wrapper exists rather than rendering the content
 * component directly.
 */
export const CliveInsightsView: React.FC = () => {
  const { claim } = useClaim({ claimRequired: true });
  const { userOrganization } = useCms();
  const lastTrackedClaimId = useRef<typeof claim.id | null>(null);

  // The tab component mounts only when its route is active, so this effect captures
  // "the Insights tab was opened". Guarding on the claim ID handles StrictMode's
  // double-invoke on mount while still re-tracking if the user switches claims
  // while this component remains mounted.
  useEffect(() => {
    if (lastTrackedClaimId.current === claim.id) {
      return;
    }
    lastTrackedClaimId.current = claim.id;
    mixpanel.track(MIXPANEL_EVENTS.INSIGHT_EVENTS.INSIGHTS_TAB_VIEWED, {
      claim_id: claim.id,
      lob: claim.lob,
      org_id: userOrganization.id,
    });
  }, [claim.id, claim.lob, userOrganization.id]);

  return <CliveInsightsContentV2 />;
};
